var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFirst(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "59px",
    viewBox: "0 0 52 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C24.836556,0 32,7.18018102 32,16.0373832 C32,20.8685844 29.8687274,25.2008371 26.4971752,28.1410666 L16.0250448,39 L5.52692836,28.1620446 C2.1414336,25.221464 0,20.8800872 0,16.0373832 C0,7.18018102 7.163444,0 16,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-53.1%",
    y: "-33.3%",
    width: "206.2%",
    height: "187.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-40.6%",
    y: "-40.6%",
    width: "181.2%",
    height: "181.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u65B0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 11,
    transform: "translate(-809.000000, -439.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-2",
    transform: "translate(819.000000, 445.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#91C61B",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u6587\\u6863",
    filter: "url(#filter-3)",
    transform: "translate(8.000000, 8.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.546875,13.5390625 C3.74472885,13.5381154 3.0946971,12.8880836 3.09375,12.0859375 L3.09375,3.1484375 L3.046875,3.1484375 C2.37377796,3.1484375 1.828125,3.69409046 1.828125,4.3671875 L1.828125,13.6796875 C1.828125,14.3527845 2.37377796,14.8984375 3.046875,14.8984375 L10.984375,14.8984375 C11.657472,14.8984375 12.203125,14.3527845 12.203125,13.6796875 L12.203125,13.5390625 L4.546875,13.5390625 Z M11.015625,1.1015625 L5.015625,1.1015625 C4.34252796,1.1015625 3.796875,1.64721546 3.796875,2.3203125 L3.796875,11.6328125 C3.796875,12.3059095 4.34252796,12.8515625 5.015625,12.8515625 L12.953125,12.8515625 C13.626222,12.8515625 14.171875,12.3059095 14.171875,11.6328125 L14.171875,4.2578125 L11.015625,1.1015625 Z M11.734375,9.8515625 L6.234375,9.8515625 C5.97549152,9.8515625 5.765625,9.64169598 5.765625,9.3828125 C5.765625,9.12392902 5.97549152,8.9140625 6.234375,8.9140625 L11.734375,8.9140625 C11.9932585,8.9140625 12.203125,9.12392902 12.203125,9.3828125 C12.203125,9.64169598 11.9932585,9.8515625 11.734375,9.8515625 Z M11.734375,7.9296875 L6.234375,7.9296875 C5.97549152,7.9296875 5.765625,7.71982098 5.765625,7.4609375 C5.765625,7.20205402 5.97549152,6.9921875 6.234375,6.9921875 L11.734375,6.9921875 C11.9932585,6.9921875 12.203125,7.20205402 12.203125,7.4609375 C12.203125,7.71982098 11.9932585,7.9296875 11.734375,7.9296875 L11.734375,7.9296875 Z M11.734375,6.0078125 L6.234375,6.0078125 C5.97549152,6.0078125 5.765625,5.79794598 5.765625,5.5390625 C5.765625,5.28017902 5.97549152,5.0703125 6.234375,5.0703125 L11.734375,5.0703125 C11.9932585,5.0703125 12.203125,5.28017902 12.203125,5.5390625 C12.203125,5.79794598 11.9932585,6.0078125 11.734375,6.0078125 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFirst);
export default __webpack_public_path__ + "static/media/icon_first.08b957f861dcf385218e5c71b11d54d8.svg";
export { ForwardRef as ReactComponent };